export function getLastPartOfURL() {
    return window.location.pathname.split("/").pop();
}